export default {
  GatewayDeviceManagement: 'Gateway Device Management',
  GatewayDevice: 'Gateway Device',
  GatewayInformation: 'Gateway Information',
  NetworkConfig: 'Network Configuration',
  NATConfig: 'NAT Configuration',
  WANConfig: 'WAN Port Configuration',
  LANConfig: 'LAN Port Configuration',
  VLANConfig: 'VLAN Configuration',
  LoopBackConfig: 'LoopBack Configuration',
  DNSConfig: 'DNS Configuration',
  ADDConfig: 'Add Configuration',
  DeleteConfirm: 'Are you sure you want to delete this configuration?',
  AssociatedDevices: 'Associated Devices',
  AssociatedDevicesPlaceholder: 'Please select to associate device',
  ConnectionMode: 'Connection Mode',
  VlanPortMode: 'Vlan-Port Mode',
  VlanID: 'Vlan ID',
  LogicPort: 'Logic Port',
  PhysicalPort: 'Physical Port',
  AddVlanConf: 'Add VLAN Config',
  AddLoopBackConf: 'Add LoopBack Config',
  LogicPopover: (
    vlanCount: number = 0,
    loopbackCount: number = 0,
    vlanLimit: number = 0,
    loopbackLimit: number = 0
  ) => {
    const vlan = `${vlanCount} vlan configurations have been configured`
    const loopback = `${loopbackCount} loopback configurations have been configured`
    const vlanlimit = vlanLimit
      ? vlanCount >= vlanLimit
        ? ', the number of configurations has reached the upper limit；'
        : `, the maximum configuration quantity is ${vlanLimit}；`
      : '；'
    const loopbacklimit = loopbackLimit
      ? loopbackCount >= loopbackLimit
        ? ', the number of configurations has reached the upper limit；'
        : `, the maximum configuration quantity is ${loopbackLimit}；`
      : '；'
    return `${vlan}${vlanlimit}${loopback}${loopbacklimit}`
  },
  DefaultVlanId: 'Default ID',
  DnsAddress1: 'DNS Address 1',
  DnsAddress2: 'DNS Address 2',
  ConnectionModePlaceholder: 'Please select connection mode',
  WorkModePlaceholder: 'Please select work mode',
  VlanPortModePlaceholder: 'Please select vlan-port mode',
  VlanIDPlaceholder: 'Fill in a positive integer ranging from 1 to 4094',
  MultiVlanIDPlaceholder: 'Fill in 1-4094, separated by multiple commas, and support the range, such as 2,14-20',
  DefaultVlanIdPlaceholder: 'Defaults to 1 and cannot overlap with VLAN ID',
  DnsAddress1Placeholder: 'Please fill in the address of the primary DNS server (optional)',
  DnsAddress2Placeholder: 'Please fill in the address of the alternate DNS server (optional)',
  IPAddress: 'IP address',
  Netmask: 'Mask',
  Gateway: 'Gateway',
  PortName: 'Port Name',
  BranchIsRequire: 'Branch cannot be empty',
  IspsIsRequire: 'ISP cannot be empty',
  CityIsRequire: 'Access location cannot be empty',
  BasicInfo: 'Basic Information',
  GatewayStatus: 'Gateway Status',
  Accesspoint: 'Access Point',
  IspsPlaceholder: 'Please choose the ISP',
  Branch: 'Branch',
  Save: 'Save',
  LastTime: 'Last Time',
  ActiveSuccess: 'Activation success',
  Active: 'Activate',
  CpeSN: 'Device number /License ID',
  CpeStatus: 'Device status',
  ActiveAt: 'Active At',
  OnlineAt: 'Last time online',
  OfflineAt: 'Last time offline',
  ActiveCpe: 'Activate device',
  CpeSN1: 'Device 1 SN No.',
  CpeCheck: 'Device Check',
  CpePlaceholder: 'Please enter the last six digits of the device SN number',
  Priority: 'Priority',
  Weight: 'Weight',
  WANIPPlaceholder: 'Please fill in the IP address of the WAN port',
  WANNetMaskPlaceholder: 'Please fill in the IP address mask of the WAN port',
  WANGatewayPlaceholder: 'Please fill in the gateway IP address of the current device',
  WANExchangeModeConfigTips: 'Tip: if you have configured NAT, high link availability, policy routing, and use the current physical port. Switching to switch mode will result in policy / configuration failure. You also need to configure VLAN and modify the original policy / configuration to the newly configured VLAN port.',
  LANExchangeModeConfigTips: 'Tip: if you have configured NAT, policy routing and use the current physical port. Switching to switch mode will result in policy / configuration failure. You also need to configure VLAN and modify the original policy / configuration to the newly configured VLAN port.',
  Account: 'Account',
  Password: 'Password',
  TotalCount: (count: number) => `Total ${count} items`,
  Add: 'Add',
  NetworkName: 'Physical Network name',
  NetworkNameRequire: 'Please choose the physical network name of the current device',
  PriorityHelp: 'In multi-WAN ports, you can specify a priority for each WAN port, with the highest priority port as the primary port' ,
  PriorityTips: 'Fill in 1 to 200, the smaller the number, the higher the priority, default is 200(optional)',
  SaveAndEnable: 'Save and enable',
  WANAccountPlaceholder: 'Please fill in your account',
  WANPasswordPlaceholder: 'Please fill in your password',
  WANWeightHelp: ' If the same priority exists in multi-WAN port conditions, you can assign a weight to each WAN port, and the higher the weight, the greater the proportion of traffic forwarded to each WAN port. If not set, it is considered to be evenly distributed. 0 is not forwarding',
  WANWeightPlaceholder: 'Fill in 0 to 50, the higher the value, the higher the weight, default is 0(optional)',
  StartIp: 'Address Pool Start IP Address',
  EndIp: 'Address Pool End IP Address',
  StartIpPlaceholder: 'Please fill in the DHCP address pool start IP address',
  EndIpPlaceholder: 'Please fill in the DHCP address pool end IP address',
  DefaultGateway: 'Default Gateway',
  DefaultGatewayPlaceholder: 'Default as current device network IP(optional)',
  Expire: 'Lease time',
  ExpirePlaceholder: 'Please fill in the occupancy time for the IP address, default is 24 hours (optional)',
  Hour: 'Hour',
  LANIPPlaceholder: 'Please fill in the IP address of the LAN port',
  LANNetMaskPlaceholder: 'Please fill in the IP address mask of the LAN port',
  IPPlaceholder: 'Please fill in the IP address',
  NetMaskPlaceholder: 'Please fill in the IP address mask',
  DNSName: 'DNS name',
  DNS1Placeholder: 'Please fill in the DNS address of the current device configuration',
  DNS2Placeholder: 'Please fill in the DNS address (backup) of the current device configuration',
  DNS2Help: 'You can configure two DNS IPs on one device, the first one is default as primary address',
  SNATConfig: 'SNAT Configuration',
  DNATConfig: 'DNAT Configuration',
  SNATTips: ' When SNAT is configured, the internal network address is converted to an extranet address, and the internal network can access the external network through the converted extranet address, but the external network cannot initiate access to the internal network through the converted address. ',
  DNATTips: ' When DNAT is configured, the internal address is mapped to external network address so that the internal network can be serviced externally, and external network can access the internal network through mapped addresses. ',
  NATDeleteConfirm: 'Are you sure you want to delete the current rule?',
  SrcIp: 'Intranet IP', // Origin IP
  SrcIpPlaceholder: 'The origin IP address before conversion, supporting single IP address or IP segment',
  SrcIpSinglePlaceholder: 'The origin IP address before conversion, supporting single IP address',
  DNATSrcIpSinglePlaceholder: 'The destination IP address before conversion, supporting single IP address',
  SrcIpRequire: 'Please fill in intranet IP',
  SrcIpHelp: 'Example:192.168.10.10 or 192.168.10.0/24',
  DestIp: 'Mapping IP', // Destination IP
  DestIpRequire: 'Please fill in the mapping IP',
  DestIpHelp: 'Example:192.168.10.10 or 192.168.123.10-192.168.123.200',
  MappingMode: 'Mapping mode',
  MappingModePlaceholder: 'Please choose mapping mode',
  DestPort: 'Intranet port', // Destination port
  SrcPort: 'Extranet Port', // Origin Port
  SrcPortRequire: 'Please fill in the extranet port',
  DestPortRequire: 'Please fill in the intranet port',
  Protocol: 'Protocol',
  ProtocolPlaceholder: 'Please select the protocol',
  SNATRule: 'SNAT Rules',
  DNATRule: 'DNAT Rules',
  isNotActive: 'Pending activation',
  Online:  'Online',
  Offline: 'Offline',
  ActiveError: 'Activation failed',
  CpeIdRequire: 'Please select the associated device',
  EquipmentType: 'Device model',
  PriorityisInValid: 'Priority does not meet the requirements, support 1 to 200, please modify',
  WeightisInValid: 'The weight does not meet the requirements, support 0 ~ 50, please modify',
  CpeConfigOverview: 'Device Configuration Overview',
  CpeConfigInfo: 'Device Configuration Information',
  NetmaskPlaceholder: 'Please fill in the subnet mask',
  DHCPIPError: 'The DHCP address pool start address must be smaller than the end address',
  ChangeTo: 'Change to',
  WLANTips: 'The current gateway device supports wireless (Wi-Fi) capability, and a PC or mobile device can access the network via Wi-Fi. To access the Internet, you need to ensure that the network address transition has been configured',
  WLANSSIDPlaceholder: 'Please fill in the wireless network name, support English and numbers, 20 characters',
  WLANSSIDBroadcast: 'SSID broadcast',
  WLANSSIDBroadcastTips: 'When SSID broadcast is turned on, wireless devices can only search for the WI-FI signal with that SSID name. When turned off, the WI-FI signal will be hidden and can only be connected by manually entering the SSID and password.',
  WLANSSIDError: 'SSID only supports upper and lower case English and numbers',
  SafetyCertification: 'Security Verification',
  SafetyCertificationTips: 'Turn on security authentication and require password setting. Users need to enter the password for verification when accessing. \nWhen security authentication is disabled, key is not required, and any user can access.',
  WLANIPPlaceholder: 'Please fill in the IP address of the WLAN port',
  AuthType: 'Authentication Type',
  WIFIPassword: 'Wifi Password',
  ConfirmPassword: 'Confirm Password',
  WIFIPasswordPlaceholder: 'Set WI-FI password, support English and numbers, 8~32 characters',
  WIFIConfirmPasswordPlaceholder: 'Confirm WI-FI password, support English and numbers, 8~32 characters',
  WIFIPasswordError: 'Password format is not correct, please re-enter',
  WIFIComfirmPasswordError: 'Password does not match, please re-enter',
  Port: 'Port',
  PortNumber: 'Port Number',
  WANorLAN: 'WAN port/LAN port',
  NetsConfStatusDesc: {
    type: {
      wan: 'The WAN port has been configured',
      lan: 'The LAN port has been configured',
      exchange: 'A switch port has been configured',
    },
    workMode: {
      route: ', the current mode is routing',
      exchange: ', the current mode is switch',
    },
    portMode: {
      access: '（access）',
      trunk: '（trunk）'
    },
    isForward: ', is currently the traffic forwarding port',
    portStatus: {
      fault: ', is currently the traffic forwarding port.',
      normal: ', the current physical port is normal.'
    },
    options: {
      WAN: 'Click Modify configuration (To ensure normal gateway services, the configuration of a single WAN port cannot be switched or deleted)',
      multiWAN: 'Click modify configuration or change the port type to LAN port',
      LAN: 'Click to modify the configuration or change the port type to WAN'
    }
  },
  WlanIsEnable: 'WLAN has been configured, the current WI-FI status is enabled, click to disable or modify the configuration',
  DnsModify: 'DNS is configured, click to modify',
  WifiMode: 'WI-FI mode',
  WifiStatu: 'WI-FI Status',
  NotConfig: (name: string) => `Unconfigured, click to add ${name} configuration`,
  MobileDisable: 'configured, the current physical port is disabled, please check the sim card and configuration. Click to deactivate or modify the configuration',
  MobileConnect: (level: string) => `configured, current signal ${level}, click to deactivate or modify the configuration`,
  MobileConnectNotForwarding: (level: string) => `configured, current physical port is enabled, signal ${level}, not participating in traffic forwarding. Click to deactivate or modify the configuration`,
  MobileConnectIsForwarding: (level: string) => `configured and is currently a traffic forwarding port with signal ${level}. Click to deactivate or modify the configuration`,
  MobileDBLevelHigh: 'High',
  MobileDBLevelGood: 'Good',
  MobileDBLevelWeak: 'Weak',
  MobileDBLevelWeakest: 'Weakest',
  ConfigDisable: (name: string) => `${name} has been configured, the current ${name} status is disabled, click to enable or modify the configuration`,
  ExpireError: 'Lease time support up to 168 hours (7 days), please modify',
  MobileConfig: '5G/4G Configuration',
  DialingStatus: 'Dialing Status',
  SubnetMask: 'Subnet Mask',
  MobileTips: 'The gateway device does not come with a sim card by default. You will need to purchase a sim card from your carrier that can transmit data. After configuration, the system will try to dial up the number, and the dial-up connection may incur charges, which need to be paid to the carrier. If you plan on using it, you can choose to disable.',
  APNSetting: 'APN Setting',
  AccesspointPlaceholder: 'Please enter the name of the access point',
  APNSettingPlaceholder: 'Please enter the username of APN Setting',
  APNPasswordPlaceholder: 'Please enter the password of APN Setting',
  DisableTitle: (title: string) => `Are you sure you want to deactivate the ${title} function for the current device?`,
  WifiExpireError: 'Please enter an integer, maximum is 168',
  WANTips: 'You can connect your local network to BaishanCloud network through WAN(Wide Area Network) port to interoperate with other branches.',
  LANTips: 'If your LAN port is connected to a local network with a large number of non-fixed local users, you can enable DHCP Server to dynamically manage and assign IP addresses. If you need to access the Internet, make sure you have configured network address translation',
  policyRouter: 'Policy Router',
  PolicyRouteTips: 'Policy links is a flexible packet links and forwarding mechanism. If you need to access multiple broadband lines and assign a Link to access a specific network, you can customize the policy to ensure that data accessing a specific destination takes the corresponding Link. Policy links has the highest data forwarding priority. If you set up multiple policies with overlapping origin address segments, the system will by default take effect based on the enabled policy sort by serial number.',
  GatewayBindingDevice: 'Gateway Associated Device',
  PolicyList: 'Policy List',
  PolicySwitch: 'Policy Switch',
  PolicyName: 'Policy Name',
  SourceIP: 'Origin IP',
  TargetIP: 'Target IP',
  NextHop: 'Next',
  PolicyNamePlaceholder: 'Please fill in, support Chinese, English, numbers and underscore, limited to 15 characters',
  PolicyNameError: 'Format error, support Chinese and English characters, numbers and underscore',
  PolicyLengthLimitTips: (num: number) => `A device can support up to ${num} policies, the maximum number is currently reached`,
  StartIPandEndIpCheck: 'The starting address must be less than or equal to the ending address',
  NextHopError: 'The input format is wrong, please fill in the correct ip address',
  DeletePolicyConfirm: 'Are you sure you want to delete this policy?',
  Custom: 'Customize',
  DeleteMobileConfirm: 'If you have set up a policy links/high availability configuration, deleting the 5G/4G configuration will delete the associated policy and configuration, and if there is only one egress link after deletion, it will turn off link-level high availability, and you can configure it again if needed. Please confirm the risk and agree to the deletion first',
  DisableMobileConfirm: 'If you have set up policy links/high availability, deactivating 5G/4G function will delete the associated policy and will no longer participate in traffic forwarding and primary/backup switching, you can configure it again if needed. Please confirm the risk and agree to the deletion first',
  MoreDeleteConfirmTips: 'Acknowledged risk and agreed to remove associated policy links and high availability configuration',
  DeleteWANConfirm: 'If you have set up policy links/high availability configuration, deleting WAN port configuration/replacing LAN port configuration will delete the associated policy and configuration, and if there is only one egress link after deletion, it will turn off link-level high availability, you can configure it again if needed. Please confirm the risk and agree to the deletion first',
  WANRemarkPlaceholder: 'Please fill in the ISP or business type, limited to 20 characters',
  HighAvailability: 'Highly Available Configuration',
  CpeHighAvailabilityTips: 'Device level high availability: The gateway is bound to multiple devices and is activated for high availability. The devices are connected in primary and backup mode and are online at the same time. The primary device participates in traffic forwarding and automatically switches to the backup device when the primary device fails to ensure uninterrupted service.',
  LinkHighAvailabilityTips: 'Link-level high availability: The gateway device will automatically enable Link-level high availability when configured with multiple outlets. Default primary and backup mode, traffic forwarding priority selects the one with higher priority as the primary Link, and automatically switches to the backup Link when the primary Link fails, and automatically switches back to the primary Link after the failure is recovered to achieve disaster recovery. You can customize the Link forwarding by setting up the priority or traffic forwarding weight.',
  CpeHighAvailability: 'Device-level high availability',
  LinkHighAvailability: 'Link-level high availability',
  FunctionStatus: 'Function Status',
  WorkMode: 'Work Mode',
  CurrentFowardingCpe: 'Current Forwarding Device',
  CurrentFowardingLink: 'Current Forwarding Links',
  AvailableAndAllCpe: 'Available/all activated devices',
  AvailableAndAllLink: 'Available/all links',
  CurrentFlowDevice: 'Current Traffic Forwarding Devices',
  Main: 'Main',
  Prepare: 'Backup',
  CpeOnlinePopover: 'Equipment Online',
  CpeOfflinePopover: 'Equipment Offline',
  CloseHighAvailabilityTitle: 'Turn off device-level high availability',
  CloseHighAvailabilityContent: 'After turning off, if the current traffic forwarding device fails, there will be no device switching, which may cause business interruption',
  EditConfig: 'Edit Configuration',
  EditConfigPopover: 'Modification may cause service suspension ( 5s - 10s), please confirm the impact on the service',
  FunctionStatusTips: 'The device is currently configured with only one egress link, to enable link-level high availability you need to configure multiple egresses, go to',
  FunctionEmptyStatusTips: 'The current device is not configured with egress links, to enable link-level high availability you need to configure multiple egresses, go to',
  AllLinks: 'All links',
  LinkPriority: 'Link Priority',
  CurrentFlowLink: 'Current traffic forwarding links',
  CurrentFlowLinkToolTips: 'Current traffic forwarding links show the available links involved in forwarding, there is a certain time delay for cutback',
  AllLinksToolTips: 'It shows the currently configured WAN links and wireless 5G/4G links of the device. If not configured, you can go to',
  LinkPriorityToolTips: 'The priority level is used to indicate the link primary and secondary relationship. Traffic is forwarded to the primary link first, when the primary link fails, it automatically switches to the backup link. If you set the same priority, the one created earlier will take first priority.',
  LinkWeightToolTips: 'The weight indicates the weight of traffic forwarding. You can specify the forwarding weight to achieve traffic load balancing. 0 means no traffic forwarding.',
  LinkDisable: 'Link Failure',
  LinkEnable: 'Link Enabled',
  MobileLinkDisable: 'Link Failure/Disabled',
  LinkLabel: 'Link Name',
  EquipmentTips1: 'Note: When the gateway binds multiple devices, the default dual cold standby mode, it does not automatically switch when fails. You can turn it on in the high availability settings',
  EquipmentTips2: '，Equipments are online at the same time, the system automatically detects failures and switches devices to ensure uninterrupted business.',
  DeviceSN: 'Device License ID',
  ConfigTotalPort: 'Configured/Total Ports',
  SetvalueInvalid: 'The setting value does not conform to the specification, please modify',
  FlowWeight: 'Traffic forwarding weight',
  RepeatPriorityTips: 'The same priority already exists traffic forwarding will be based on the earlier creation as first priority.',
  LinksDataEmpty: 'The device is not currently configured with an egress link, go to',
  CpeFunctionStatusCloseTips: 'Only one device is bound to the current gateway instance, and more than 2 active devices are required to enable device-level high availability',
  CpeFunctionStatusEmptyTips: 'The current gateway instance is not bound to a device, and at least 2 activated devices are required to enable device-level high availability',
  OtherCpe: 'Other Device',
  MainCpe: 'Primary Device',
  MainCpeAndPort: 'Primary Device and Port',
  MainCpeAndPortTips: 'Please select the primary device and configure HA ports for all devices',
  MainCpeAndPortNeedSetTips: 'Please configure the HA port for the device with missing configuration',
  SureEnable: 'Confirm to Enable',
  EspeciallyNotice: 'Note: Traffic forwarding uses primary device by default, when the primary device fails, it will switch to the backup device to achieve data forwarding, the configuration of the backup device will take effect. Please check the configuration of the backup device (network configuration, NAT, policy routing, high availability configuration) to see if it meets your business requirements.',
  CpeHighAvailabilityOpen: 'Device level high availability is enabled',
  CpeHighAvailabilitySuccessTips: 'Traffic forwarding uses primary device by default, when the primary device fails, it will switch to the backup device and automatically cut back after the recovery of the failure.',
  CpeHighAvailabilityEmpty: 'The current gateway is not bound to the device, please contact customer service',
  OutPort: 'out interface',
  MappingOutPortExtra: 'Tip: For the same device, if you add multiple configurations with the same intranet IP, the one created earlier will take effect first.',
  OpenHAPort: 'Open HA port',
  EnableFunctionPort: 'Enable function port',
  VirtualIP: 'Virtual IP',
  VirtualIPExtra: 'Reminder: The virtual IP address must be in the same network segment as the real IP of the device HA port and cannot conflict with the IP address already assigned in the network segment.',
  VirtualIPPlaceholder: 'Please fill in the virtual IP address, such as 192.168.0.2',
  HAPortloss: 'HA port configuration is missing, please',
  CpeConfigInfoTips1: ' Note: When the gateway device is configured with multiple outlets, the system defaults to the earliest added wired link as the primary link and the rest as the backup link. Wireless 5G/4G has the lowest priority. You can go to',
  CpeConfigInfoTips2: 'to set up customize link forwarding',
  PolicyRouterDisableTips: 'The current link is not available because the gateway device at the other end is not online',
  PhysicalPortFailure: 'Physical port failuer',
  PhysicalPortNormal: 'Physical port is normal',
  CurrentSignal: 'Current Signal',
  HASettingLoss: 'The current device is missing and does not participate in traffic forwarding and failover, please check',
  MatchingRules: 'Matching rules',
  MappingRules: 'Mapping rule',
  InPort: 'Incoming interface',
  MappingPort: 'Mapped port',
  DestIpPlaceholder: 'The converted source IP address supports a single IP address',
  PortPlaceholder: 'Please fill in a single port, the value range is from 1 to 65535',
  DNATDestIpPlaceholder: 'Please fill in a single IP address',
  NATProtocolTips: 'Prompt: The specified port is not supported when the protocol is ALL/ICMP type',
  MoreDisableMobileConfirmTips: 'Confirmed the risk and agreed to delete the associated policy routing/NAT configuration',
  MoreDeleteLanConfirm: 'If you have set the NAT configuration, deleting the LAN port configuration/changing the WAN port configuration will also delete the associated configuration. You can configure it again if necessary. Please confirm the risk and agree to delete',
  MoreDeleteLanConfirmTips: 'Confirmed the risk and agreed to delete the associated NAT configuration',
  MoreDeleteVLanConfirm: 'If you have set policy routing / NAT configuration / high availability, deleting VLAN configuration will delete the associated policy and configuration together, or cause high availability to fail. You can configure it again if necessary. Please confirm the risk first and agree to delete it',
  MoreDeleteVLanConfirmTips: 'Confirmed the risk and agreed to delete the associated policy routing /nat configuration',
  MoreDeleteLoopBackConfirm: 'If you have set the NAT configuration, deleting the logical port configuration will invalidate the relevant configuration. You can configure it again if necessary. Please confirm the risk first and agree to delete it',
  MoreDeleteLoopBackConfirmTips: 'The risk has been confirmed and the associated NAT configuration has been agreed to be deleted',
  OutletPort: 'Outlet Port',
  CPENickname: 'Cpe nickname',
  EditBranchPlaceholder: 'You can name the gateway and fill in the branch name',
  BranchPlaceholder: 'Branch only support Chinese and English numbers, limited to 10 characters',
  AliasNameRequire: 'AliasName only support Chinese and English numbers, limited to 10 characters',
  NATSwitchTips: (title: string) =>  `Your ${title} configuration is used for the device to connect to the Internet, if it is turned off cannot connect to the Internet`,
  DNATSwithTips: 'Confirm to close DNAT?',
  NetworkModule: 'network module',
  PolicyDeliveryStatus: 'Policy Delivery Status',
  ResultsEnforcement: 'results of enforcement',
  PolicyDeliveryTime: 'Policy Delivery Time',
  RoutingRules: 'Routing rules',
  InPortErrorTips: 'If the source address is not set, set the inbound interface or add a matching rule for the source address',
  ChangePriority: 'Adjust priority',
  SavePriority: 'Save priority',
  SrcDestIpErrorTips: 'The source and destination addresses cannot be set to any at the same time (0.0.0.0-255.255.255.255 or empty), please add',
  PolicyStatusTips1: (num: number) => `All successfully delivered, a total of ${num}, all executed successfully`,
  PolicyStatusTips2: (num: number, detail: string) => `${num} items were delivered successfully, but execution was interrupted due to ${detail}. After modification or closing the policy, the delivery action will be re-executed.`,
  PolicyStatusTips3: 'Successfully issued 0, failed to execute successfully, please re-edit and submit or restart to restart the delivery',
  ExecutionStatus: 'Execution status',
  DiagnosticTools: 'Diagnostic Tools',
  NetworkDetection: 'Network Detection',
  NetworkDetectionTips: 'Use the ping (Packet Internet Groper) command to test the network connection. You can use the command to check whether the network is smooth or the speed of the network connection.',
  NetworkSpeedTest: 'network speed test',
  NetworkSpeedTestTips: 'Speedtest tool Speedtest supports statistics of bandwidth rate, delay, packet loss and other information. You can use it to evaluate public network network performance, locate problems, and solve network faults.',
  LinkProbe: 'Link Probe',
  LinkProbeTips: 'The detection tool iperf supports statistics on link quality indicator data. You can use it to test the network performance to the target peer, locate problems, and solve network faults.',
  CommonParameters: 'Common Parameters',
  TargetIPPlaceholder: 'Please enter a domain name/IP address',
  NumberOfPackages: 'Number of packages',
  NumberOfPackagesPlaceholder: 'Please fill in a positive integer from 1-100, if not fill in, the default is 5',
  ResultExecution: 'Result of Execution',
  NetworkExit: 'Network Exit',
  NetworkExitTips: 'Special Note: It is recommended to select the business idle time for speed measurement. Otherwise, network services may be affected by occupying bandwidth.',
  TargetPeer: 'Target Peer',
  RequestError: 'Request failed, failed to execute successfully',
  BandwidthRate: 'Bandwidth Rate',
  Upload: 'Upload',
  Download: 'Download',
  NetworkQuality: 'Network Quality',
  ReasonForFailure: 'Reason for failure',
  OutletPortExtra: (portName: string) => `Special note: The current deployment port of the CPE is [${portName}], and the egress port should be avoided to select the deployment port to avoid deployment failure.`,
  GatewayPlaceholder: 'Please input the gateway ip',
  NetType: 'Network Type',
  VlanNetTypeExtra: 'Tip: If you have configured NAT, policy routing, high availability and use the current logical port. After switching the network type, the policy/configuration may become invalid. If necessary, it is recommended to modify the association policy before modifying the logical port.',
  DefaultDNS: 'Default DNS',
  PrivateDNS: 'Private DNS',
  PrivateDomainName: 'PrivateDomainName',
  PrivateDNS2Extra: 'Tip: The first address is the main address by default. If it is left blank, it will be saved according to the default configuration. Default configuration: primary DNS 119.29.29.29, secondary DNS 114.114.114.114.',
  PrivateDomainNameExtra: 'Please fill in the domain name, support multiple, one line, up to 300. Support pan-domain name, format: .domain.com',
  PrivateDomainError: 'Support up to 300 domain names, one line, please modify as required',
  PrivateDNSErrorTips: 'If you need to configure private network DNS, please fill in the DNS address and private network domain name',
  DNSAlertTips: 'You can configure the default DNS and private network DNS for the device, and support the configuration of both primary and secondary addresses. The private domain names that do not match the traffic are resolved according to the default DNS.',
  MTUPlaceholder: 'Please fill in the positive integer of 68-1500, and the default is 1500 if not filled in',
  MTUPlaceholder2: 'Please fill in the positive integer of 128-1492, and the default is 1492 if not filled in',
  MSSPlaceholder: 'Please fill in the positive integer of 500-1460, and the default is 1460 if not filled in',
  MSSPlaceholder2: 'Please fill in the positive integer of 500-1452, and the default is 1460 if not filled in',
  MaxLengthErrorTips: (name: string, num: number) => `The number of ${name} configurations of the current device has reached the maximum of ${num}`,
  forwardMax: 'Maximum number of forwards',
  forwardMaxPlaceholder: 'Enter a positive integer greater than 150. The default value is 150',
  Static: 'Static',
  StaticAddress: 'Static address',
  DHCPConfigTips: 'DHCP static address has been configured. You can view the allocation details in the DHCP allocation table below',
  ClientIP: 'Client IP',
  ClientMAC: 'Client MAC',
  PleaseFillInMACAddress: 'Please fill in MAC address',
  AllocationResult: 'Allocation Result',
}